import { useEffect, useState } from "react";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { useEventStore } from "@/store/events/events.store";
import { Event } from "@/models/Events.model";

export const useSingleEvent = (slug: string) => {
  const { events, setEvents } = useEventStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const querySnapshot = await collectionRef.Events.where(
        "slug",
        "==",
        slug
      ).get();
      const data: Event[] = [];
      querySnapshot.forEach((doc) => {
        const eventData = doc.data() as Omit<Event, "slug">;
        const event = {
          ...eventData,
          slug: doc.id,
        } as Event;
        data.push(event);
      });
      setEvents(data);
      setLoading(false);
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!events || !events.some((brand) => brand.slug === slug)) {
      fetchData();
    }
  }, [events, slug]);

  return {
    data: events?.find((brand) => brand.slug === slug) || null,
    loading,
    error,
  };
};
